import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "property-form-row" }
const _hoisted_2 = { class: "property-form-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_computed_input = _resolveComponent("ontos-computed-input")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_ontos_alias_fields = _resolveComponent("ontos-alias-fields")!
  const _component_ontos_property_form_section = _resolveComponent("ontos-property-form-section")!
  const _component_ontos_select = _resolveComponent("ontos-select")!
  const _component_ontos_creatable_autocomplete = _resolveComponent("ontos-creatable-autocomplete")!
  const _component_ontos_colored_entry_list = _resolveComponent("ontos-colored-entry-list")!
  const _component_ontos_domain_dialog = _resolveComponent("ontos-domain-dialog")!
  const _component_ontos_property_behavior = _resolveComponent("ontos-property-behavior")!
  const _component_ontos_property_default = _resolveComponent("ontos-property-default")!
  const _component_ontos_formula_input = _resolveComponent("ontos-formula-input")!
  const _component_ontos_rollup_builder = _resolveComponent("ontos-rollup-builder")!
  const _component_ontos_property_form_layout = _resolveComponent("ontos-property-form-layout")!
  const _component_ontos_option_filter_input = _resolveComponent("ontos-option-filter-input")!
  const _component_ontos_rules_input = _resolveComponent("ontos-rules-input")!
  const _component_ontos_access_input = _resolveComponent("ontos-access-input")!
  const _component_ontos_property_tabs = _resolveComponent("ontos-property-tabs")!

  return (_openBlock(), _createBlock(_component_ontos_property_tabs, {
    ref: "tabs",
    validation: _ctx.canFilterOptions || _ctx.canHaveRules,
    invalid: _ctx.invalidTabs
  }, {
    property: _withCtx(() => [
      _createVNode(_component_ontos_property_form_layout, null, _createSlots({
        main: _withCtx(() => [
          _createVNode(_component_ontos_property_form_section, {
            title: _ctx.$tt('section.identity')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.model.type === 'choice')
                  ? (_openBlock(), _createBlock(_component_ontos_computed_input, {
                      key: 0,
                      label: _ctx.$tt('attribute-name'),
                      class: "required unique",
                      "hide-details": "auto",
                      value: _ctx.model.name,
                      manual: _ctx.manualName,
                      "onInput:manual": _cache[0] || (_cache[0] = ($event: any) => (_ctx.manualName = $event)),
                      source: _ctx.model.domain,
                      compute: _ctx.computeName,
                      "error-messages": _ctx.errorMessages.name,
                      onInput: _cache[1] || (_cache[1] = ($event: any) => {_ctx.model.name = $event; _ctx.validateName($event)}),
                      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateName()))
                    }, null, 8, ["label", "value", "manual", "source", "compute", "error-messages"]))
                  : (_openBlock(), _createBlock(_component_v_text_field, {
                      key: 1,
                      class: "required unique",
                      label: _ctx.$tt('attribute-name'),
                      modelValue: _ctx.model.name,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.name) = $event)),
                        _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateName($event)))
                      ],
                      "hide-details": "auto",
                      "error-messages": _ctx.errorMessages.name,
                      onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateName()))
                    }, null, 8, ["label", "modelValue", "error-messages"])),
                _createVNode(_component_ontos_alias_fields, {
                  alias: _ctx.model.alias,
                  source: _ctx.model.name,
                  fixed: _ctx.fixedAlias,
                  manual: _ctx.manualAlias,
                  "onUpdate:manual": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.manualAlias) = $event)),
                  "error-message": _ctx.errorMessages.alias,
                  onInput: _cache[7] || (_cache[7] = ($event: any) => {_ctx.model.alias = $event; _ctx.validateAlias($event)}),
                  onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateAlias()))
                }, null, 8, ["alias", "source", "fixed", "manual", "error-message"])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_ontos_property_form_section, {
            title: _ctx.$tt('section.type')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_ontos_select, {
                  items: _ctx.types,
                  "item-text": "name",
                  "item-value": "alias",
                  label: _ctx.$tt('attribute-type'),
                  class: "required",
                  "hide-details": "auto",
                  modelValue: _ctx.model.type,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.type) = $event))
                }, null, 8, ["items", "label", "modelValue"]),
                (_ctx.model.type && _ctx.typesObj[_ctx.model.type].subtypes)
                  ? (_openBlock(), _createBlock(_component_ontos_select, {
                      key: 0,
                      items: _ctx.$arrays.arrayOf(_ctx.typesObj[_ctx.model.type].subtypes, 'alias'),
                      "item-text": "name",
                      "item-value": "alias",
                      "hide-details": "auto",
                      label: _ctx.$tt('attribute-subtype', {type: _ctx.typesObj[_ctx.model.type].name}),
                      class: "required",
                      modelValue: _ctx.model.subtype,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.subtype) = $event))
                    }, null, 8, ["items", "label", "modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.model.type === 'choice')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_ontos_creatable_autocomplete, {
                      items: _ctx.workspace.domains,
                      "item-title": "name",
                      "item-value": "alias",
                      class: "required domain-field",
                      label: _ctx.$tt('domain'),
                      "hide-details": "auto",
                      "model-value": _ctx.model.domain,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.onDomainPicked($event))),
                      onCreate: _cache[12] || (_cache[12] = ($event: any) => (_ctx.creatingDomainName = $event))
                    }, null, 8, ["items", "label", "model-value"]),
                    (_openBlock(), _createBlock(_component_ontos_colored_entry_list, {
                      ref: "options",
                      editable: "",
                      reorderable: "",
                      min: 1,
                      key: _ctx.model.domain || 'none',
                      resumed: _ctx.resumedOptions,
                      entries: _ctx.chosenDomain ? _ctx.chosenDomain.options : [],
                      title: _ctx.$tt('options'),
                      level: 4,
                      dense: "",
                      divider: false,
                      "create-label": _ctx.$tt('option-create'),
                      "add-disabled": !_ctx.chosenDomain,
                      "onUpdate:entries": _cache[13] || (_cache[13] = ($event: any) => (_ctx.onOptionsChanged($event)))
                    }, null, 8, ["resumed", "entries", "title", "create-label", "add-disabled"])),
                    (_ctx.creatingDomainName !== null)
                      ? (_openBlock(), _createBlock(_component_ontos_domain_dialog, {
                          key: 0,
                          workspace: _ctx.workspace,
                          "initial-name": _ctx.creatingDomainName,
                          saving: _ctx.savingDomain,
                          "full-page": false,
                          onCreate: _cache[14] || (_cache[14] = ($event: any) => (_ctx.createDomain($event))),
                          onClosed: _cache[15] || (_cache[15] = ($event: any) => (_ctx.closeDomainDialog()))
                        }, null, 8, ["workspace", "initial-name", "saving"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        side: _withCtx(() => [
          _createVNode(_component_ontos_property_form_section, {
            title: _ctx.$tt('section.behavior')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ontos_property_behavior, {
                model: _ctx.model,
                original: _ctx.value,
                kind: "attribute",
                onMultiple: _cache[16] || (_cache[16] = ($event: any) => (_ctx.model.multiple = !!$event))
              }, null, 8, ["model", "original"]),
              (_ctx.offersDefault)
                ? (_openBlock(), _createBlock(_component_ontos_property_default, {
                    key: 0,
                    ref: "default",
                    value: _ctx.model.default,
                    draft: _ctx.formulaDraft,
                    bindings: _ctx.formulaBindings,
                    options: _ctx.defaultOptions,
                    "result-label": _ctx.formulaResultLabel,
                    onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.model.default = $event))
                  }, null, 8, ["value", "draft", "bindings", "options", "result-label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 2
      }, [
        (_ctx.model.computed)
          ? {
              name: "bottom",
              fn: _withCtx(() => [
                _createVNode(_component_ontos_property_form_section, {
                  title: _ctx.$tt('section.computation')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ontos_formula_input, _mergeProps({
                      ref: "formula",
                      class: "required"
                    }, _ctx.formulaBindings, {
                      value: _ctx.model.formula,
                      "result-label": _ctx.formulaResultLabel,
                      draft: _ctx.formulaDraft,
                      example: _ctx.examples.computed,
                      onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.model.formula = $event)),
                      onValidity: _cache[19] || (_cache[19] = ($event: any) => (_ctx.formulaValid = $event))
                    }), null, 16, ["value", "result-label", "draft", "example"]),
                    _createVNode(_component_ontos_rollup_builder, {
                      idea: _ctx.idea,
                      workspace: _ctx.workspace,
                      onApply: _cache[20] || (_cache[20] = ($event: any) => (_ctx.applyRollup($event)))
                    }, null, 8, ["idea", "workspace"])
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1024)
    ]),
    validation: _withCtx(() => [
      _createVNode(_component_ontos_property_form_layout, null, {
        main: _withCtx(() => [
          (_ctx.canFilterOptions)
            ? (_openBlock(), _createBlock(_component_ontos_property_form_section, {
                key: 0,
                title: _ctx.$tt('option-filter'),
                explain: _ctx.$tt('option-filter-explain')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ontos_option_filter_input, {
                    ref: "optionFilter",
                    bindings: _ctx.formulaBindings,
                    draft: _ctx.formulaDraft,
                    example: _ctx.examples.optionFilter,
                    value: _ctx.model.optionFilter,
                    onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.model.optionFilter = $event)),
                    message: _ctx.model.optionFilterMessage,
                    onMessage: _cache[22] || (_cache[22] = ($event: any) => (_ctx.model.optionFilterMessage = $event))
                  }, null, 8, ["bindings", "draft", "example", "value", "message"])
                ]),
                _: 1
              }, 8, ["title", "explain"]))
            : _createCommentVNode("", true),
          (_ctx.canHaveRules)
            ? (_openBlock(), _createBlock(_component_ontos_property_form_section, {
                key: 1,
                title: _ctx.$tt('rules'),
                explain: _ctx.$tt('rules-explain')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ontos_rules_input, {
                    ref: "rules",
                    bindings: _ctx.formulaBindings,
                    draft: _ctx.formulaDraft,
                    example: _ctx.examples.rule,
                    rules: _ctx.model.rules,
                    onInput: _cache[23] || (_cache[23] = ($event: any) => (_ctx.model.rules = $event))
                  }, null, 8, ["bindings", "draft", "example", "rules"])
                ]),
                _: 1
              }, 8, ["title", "explain"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    access: _withCtx(() => [
      _createVNode(_component_ontos_access_input, _mergeProps({ ref: "access" }, _ctx.fieldAccessBindings({..._ctx.formulaDraft, identifier: _ctx.model.identifier},
                              undefined, _ctx.formulaBindings.current), {
        value: _ctx.model.access || {},
        onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.model.access = $event))
      }), null, 16, ["value"])
    ]),
    _: 1
  }, 8, ["validation", "invalid"]))
}